<template>
    <div class="androidFilePicker">
        <ul>
            <li>
                <button @click.prevent="addFromCamera">Camera</button>
            </li>
            <li>
                <button @click.prevent="addFromGallery">Gallery</button>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "android-file-picker",
    data() {
        return {
            oWebViewInterface: window.nsWebViewInterface,
        };
    },
    props: {
        id: {
            type: String,
            required: true,
        },
        mode: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            required: true,
        },
    },
    methods: {
        addFromCamera() {
            this.oWebViewInterface.emit("openCamera", {
                id: this.id,
                mode: this.mode,
                type: this.type,
            });
        },
        addFromGallery() {
            this.oWebViewInterface.emit("openFilePicker", {
                id: this.id,
                mode: this.mode,
                type: this.type,
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.androidFilePicker {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 200;
    ul {
        li {
            margin-bottom: 5px;
            position: relative;
            button {
                appearance: none;
                display: block;
                background: white;
                padding: 15px;
                text-decoration: none;
                border-radius: 12px;
                box-shadow: 0px 6px 10px rgb(0 0 0 / 10%) !important;
                font-size: 14px;
                color: #267962;
                border: 0px;
            }
        }
    }
}
</style>
